import styles from "@/components/ImpactReferenceSelector/ImpactReference.module.scss";
import useTableStateParams from "@/components/Table/hooks/useTableState";
import { ImpactDataset, useEcoInventDatasets } from "@/hooks/useEcoInventDatasets";
import { EcoInventDatasetTable } from "./EcoInventDatasetsTable";

export interface EcoInventDatasetsTableProps {
  selectedDataset?: ImpactDataset;
  onDatasetChange?: (id: ImpactDataset) => void;
  defaultSearch?: Record<string, any>;
  defaultFilter?: Record<string, any>;
}

export const EcoInventDatasets = ({
  selectedDataset,
  onDatasetChange,
  defaultSearch,
  defaultFilter,
  ...props
}: EcoInventDatasetsTableProps) => {
  const { pagination, filter, search, sort, onSearchFilterSortPaginate } = useTableStateParams({
    defaultPagination: { page: 1, pageSize: 20 },
    defaultFilter,
    defaultSearch: { ...defaultSearch },
    defaultSort: { key: "reference_product_name", order: "ascend" },
  });

  const { data, isLoading, isFetching } = useEcoInventDatasets({
    pagination,
    filter,
    search,
    sort,
  });

  return (
    <>
      <div className={styles.form}>
        <EcoInventDatasetTable
          {...props}
          loading={isLoading || isFetching}
          data={data?.datasets}
          onSearchFilterSortPaginate={onSearchFilterSortPaginate}
          totalRows={data?.total_count}
          pagination={pagination}
          sort={sort}
          search={search}
          filter={filter}
          onRowClick={onDatasetChange ? (record) => onDatasetChange(record) : undefined}
          activeRowKey={selectedDataset?.id}
        />
      </div>
    </>
  );
};
